import Card from "./Card";
import SimpleTable from "./SimpleTable";
import { BRAND } from "../css/brand";
import BlueButton from "./BlueButton";
import Badge from "./Badge";
import { useNavigate } from "react-router-dom";
import { CheckCircle, Eye, XCircle } from "lucide-react";

const PARENT_NAME_MAP = {
  CNF: "company_name",
  "Super Stockist": "cnf_name",
  Distributor: "ss_name",
  "Micro Distributor": "dist_name",
  Retailer: "dist_name", // or "ss_name" depending on hierarchy
};

export default function EntityTable({ title, rows, type, onToggle, meta, onPageChange }) {
  const navigate = useNavigate();
  const parentField = PARENT_NAME_MAP[type] || "—";
  if (!meta) meta = { current_page: 1, last_page: 1 };

  // Sliding window for page numbers
  const getPageNumbers = () => {
    const total = meta.last_page;
    const current = meta.current_page;
    const windowSize = 5; // show 5 page numbers at a time
    let start = Math.max(1, current - Math.floor(windowSize / 2));
    let end = start + windowSize - 1;

    if (end > total) {
      end = total;
      start = Math.max(1, end - windowSize + 1);
    }

    const pages = [];
    for (let i = start; i <= end; i++) pages.push(i);

    return pages;
  };

  const pages = getPageNumbers();

  return (
    <Card brand={BRAND} title={title}>
      <SimpleTable
        headers={[
          "ID",
          "Code",
          "Name",
          "Parent",
          "State",
          "District",
          "Status",
          "Actions",
        ]}
        rows={rows.map((r) => [
          r.id,
          r.org_code,
          r.business_name,
          r[parentField] || "—",
          r.state || "—",
          r.district || "—",
          Badge(r.is_active === 1 ? "Active" : "Inactive", r.is_active === 1 ? "blue" : "red"),
          <div className="flex  gap-2" key={`act-${r.id}`}>
            {/* ✅ View Button */}
            {type !== "Micro Distributor" && (
                <BlueButton
                  brand={BRAND}
                  onClick={() => navigate(`/dashboard/entity/${r.id}`)}
                  className="inline-flex items-center gap-1"
                >
                  <Eye size={14} />
                  <span className="hidden sm:inline">View</span>
                </BlueButton>
              )}

            {/* ✅ Toggle Button */}
            <BlueButton
              brand={BRAND}
              onClick={() => onToggle(type, r.id, r.is_active)}
              className="inline-flex items-center gap-1"
            >
              {r.is_active === 1 ? (
                <>
                  <XCircle size={14} className="text-red-500" />
                  <span className="hidden sm:inline">Deactivate</span>
                </>
              ) : (
                <>
                  <CheckCircle size={14} className="text-green-500" />
                  <span className="hidden sm:inline">Activate</span>
                </>
              )}
            </BlueButton>
          </div>,
        ])}
      />

      {/* Pagination */}

        <div className="flex gap-2 justify-end mt-3 items-center">
          <button
            disabled={meta.current_page === 1}
            onClick={() => onPageChange(meta.current_page - 1)}
            className="px-2 py-1 border rounded"
          >
            Prev
          </button>

          {pages[0] > 1 && (
            <>
              <button className="px-2 py-1 border rounded" onClick={() => onPageChange(1)}>1</button>
              {pages[0] > 2 && <span className="px-2">...</span>}
            </>
          )}

          {pages.map((p) => (
            <button
              key={p}
              className={`px-2 py-1 border rounded ${meta.current_page === p ? "bg-blue-500 text-white" : ""}`}
              onClick={() => onPageChange(p)}
            >
              {p}
            </button>
          ))}

          {pages[pages.length - 1] < meta.last_page && (
            <>
              {pages[pages.length - 1] < meta.last_page - 1 && <span className="px-2">...</span>}
              <button className="px-2 py-1 border rounded" onClick={() => onPageChange(meta.last_page)}>{meta.last_page}</button>
            </>
          )}

          <button
            disabled={meta.current_page === meta.last_page}
            onClick={() => onPageChange(meta.current_page + 1)}
            className="px-2 py-1 border rounded"
          >
            Next
          </button>
        </div>
    </Card>
  );
}

// import Card from "./Card";
// import SimpleTable from "./SimpleTable";
// import { BRAND } from "../css/brand";
// import BlueButton from "./BlueButton";
// import Badge from "./Badge";

// const PARENT_NAME_MAP = {
//   CNF: "company_name",
//   "Super Stockist": "cnf_name",
//   Distributor: "ss_name",
//   "Micro Distributor": "dist_name",
//   Retailer: "dist_name", // or "ss_name" depending on hierarchy
// };

// export default function EntityTable({ title, rows, type, onToggle, meta, onPageChange }) {
//   const parentField = PARENT_NAME_MAP[type] || "—";

//   if (!meta) meta = { current_page: 1, last_page: 1 }; // fallback

//   // Sliding window for page numbers
//   const getPageNumbers = () => {
//     const total = meta.last_page;
//     const current = meta.current_page;
//     const windowSize = 5; // show 5 page numbers at a time
//     let start = Math.max(1, current - Math.floor(windowSize / 2));
//     let end = start + windowSize - 1;

//     if (end > total) {
//       end = total;
//       start = Math.max(1, end - windowSize + 1);
//     }

//     const pages = [];
//     for (let i = start; i <= end; i++) pages.push(i);

//     return pages;
//   };

//   const pages = getPageNumbers();

//   return (
//     <Card brand={BRAND} title={title}>
//       <SimpleTable
//         headers={["ID","Code", "Name", "Parent", "State", "District", "Status", "Actions"]}
//         rows={rows.map((r) => [
//           r.id,
//           r.org_code,
//           r.business_name,
//           r[parentField] || "—",
//           r.state || "—",
//           r.district || "—",
//           Badge(r.is_active === 1 ? "Active" : "Inactive", r.is_active === 1 ? "blue" : "red"),
//           <div className="flex flex-wrap gap-2" key={`act-${r.id}`}>
//             <BlueButton
//               brand={BRAND}
//               onClick={() => onToggle(type, r.id, r.is_active)} // ✅ pass current status
//             >
//               {r.is_active === 1 ? "Deactivate" : "Activate"}
//             </BlueButton>
//           </div>,
//         ])}
//       />

//       {/* Pagination */}
//       {meta.last_page > 1 && (
//         <div className="flex gap-2 justify-end mt-3 items-center">
//           <button
//             disabled={meta.current_page === 1}
//             onClick={() => onPageChange(meta.current_page - 1)}
//             className="px-2 py-1 border rounded"
//           >
//             Prev
//           </button>

//           {pages[0] > 1 && (
//             <>
//               <button className="px-2 py-1 border rounded" onClick={() => onPageChange(1)}>1</button>
//               {pages[0] > 2 && <span className="px-2">...</span>}
//             </>
//           )}

//           {pages.map((p) => (
//             <button
//               key={p}
//               className={`px-2 py-1 border rounded ${meta.current_page === p ? "bg-blue-500 text-white" : ""}`}
//               onClick={() => onPageChange(p)}
//             >
//               {p}
//             </button>
//           ))}

//           {pages[pages.length - 1] < meta.last_page && (
//             <>
//               {pages[pages.length - 1] < meta.last_page - 1 && <span className="px-2">...</span>}
//               <button className="px-2 py-1 border rounded" onClick={() => onPageChange(meta.last_page)}>{meta.last_page}</button>
//             </>
//           )}

//           <button
//             disabled={meta.current_page === meta.last_page}
//             onClick={() => onPageChange(meta.current_page + 1)}
//             className="px-2 py-1 border rounded"
//           >
//             Next
//           </button>
//         </div>
//       )}
//     </Card>
//   );
// }


// import Card from "./Card";
// import SimpleTable from "./SimpleTable";
// import { BRAND } from "../css/brand";
// import BlueButton from "./BlueButton";
// import Badge from "./Badge";

// export default function EntityTable({ title, rows, type, onToggle, meta, onPageChange }) {
//   return (
//     <Card brand={BRAND} title={title}>
//       <SimpleTable
//         headers={["ID", "Name", "Parent", "State", "District", "Status", "Actions"]}
//         rows={rows.map((r) => [
//           r.id,
//           r.business_name,
//           r.dist_name || "—",
//           r.state || "—",
//           r.district || "—",
//           Badge(r.is_active === 1 ? "Active" : "Inactive", r.is_active === 1 ? "blue" : "red"),
//           <div className="flex flex-wrap gap-2" key={`act-${r.id}`}>
//             <BlueButton brand={BRAND} onClick={() => onToggle(type, r.id)}>
//               {r.is_active === 1 ? "Deactivate" : "Activate"}
//             </BlueButton>
//           </div>,
//         ])}
//       />

//       {/* Pagination */}
//       {meta?.last_page > 1 && (
//         <div className="flex gap-2 justify-end mt-3">
//           <button disabled={!meta?.current_page || meta.current_page === 1} onClick={() => onPageChange(meta.current_page - 1)} className="px-2 py-1 border rounded">Prev</button>
//           {Array.from({ length: meta.last_page }, (_, i) => (
//             <button
//               key={i}
//               className={`px-2 py-1 border rounded ${meta.current_page === i + 1 ? "bg-blue-500 text-white" : ""}`}
//               onClick={() => onPageChange(i + 1)}
//             >
//               {i + 1}
//             </button>
//           ))}
//           <button disabled={!meta?.current_page || meta.current_page === meta.last_page} onClick={() => onPageChange(meta.current_page + 1)} className="px-2 py-1 border rounded">Next</button>
//         </div>
//       )}
//     </Card>
//   );
// }



// import Card from "./Card";
// import SimpleTable from "./SimpleTable";
// import { BRAND } from "../css/brand";
// import BlueButton from "./BlueButton";
// import Badge from "./Badge";

// export default function EntityTable({ title, rows, type, onToggle }) {
//   return (
//     <Card brand={BRAND} title={title}>
//       <SimpleTable headers={["ID", "Name", "Parent", "State", "District", "Status", "Actions"]} rows={rows.map((r) => [r.id, r.business_name, r.dist_name || "—", r.state || "—", r.district || "—", 
//       Badge(r.is_active === 1 ? "Active" : "Inactive", r.is_active === 1 ? "blue" : "red"), 
//         <div className="flex flex-wrap gap-2" key={`act-${r.id}`}>
//           <BlueButton brand={BRAND} onClick={()=>onToggle(type, r.id)}>{r.is_active === 1 ? "Deactivate" : "Activate"}</BlueButton>
//           </div>])} />
//     </Card>
//   );
// }